<template>
  <el-select
    v-model="selectedValue"
    clearable
    :disabled="disabled"
    :multiple="multiple "
    @change="handleChange"
  >
    <el-option
      v-for="item in options"
      :disabled="((entity=='new_projectapply'||entity=='new_authorizationletter')&&attribute=='new_band'&& item.Value==3)"
      :key="item.Value"
      :label="item.Text"
      :value="item.Value"
    >{{item.Text}}</el-option>
  </el-select>
</template>

<script type="text/javascript">
export default {
  name: "RtPicklist",
  props: {
    value: [],
    entity: {
      type: String,
      required: true
    },
    attribute: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    multiple: {
      type: Boolean,
      default: false,
      required: false
    },
  },
  data() {
    return {
      selectedValue: null,
      options: []
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.selectedValue = newVal;
    }
  },
  methods: {
    bindPicklist: function() {
      var self = this;
      rt.get(
        "../api/crmpicklist/options/" + this.entity + "/" + this.attribute
      ).then(function(res) {
        self.options = res;
        if (self.value) {
          self.selectedValue = self.value;
        }
      });
    },
    handleChange(val) {
      this.$emit("input", val);

      this.$emit("change", val);
    }
  },
  mounted: function() {
    this.bindPicklist();
  }
};
</script>


// WEBPACK FOOTER //
// main.vue?00150cfd